import { cn } from "@/lib/utils";
import { ROW_TITLE } from "@/lib/typography";

interface TagLabelProps {
  name: string;
  color: string;
  size?: "xs" | "sm";
  className?: string;
  truncate?: boolean;
  /** Not confirmed yet, so it has no color. */
  suggested?: boolean;
}

const sizeClasses = {
  xs: {
    text: "text-ui-caption",
    gap: "gap-1.5",
  },
  sm: {
    text: ROW_TITLE,
    gap: "gap-2",
  },
} as const;

/** Stored tag color is decoration; the name always uses readable, inherited ink. */
export function TagDot({ color }: { color: string }) {
  return <span aria-hidden="true" className="size-2 shrink-0 rounded-full ring-1 ring-background" style={{ backgroundColor: color }} />;
}

export function TagLabel({
  name,
  color,
  size = "xs",
  className,
  truncate = false,
  suggested = false,
}: TagLabelProps) {
  const styles = sizeClasses[size];

  return (
    <span className={cn("flex min-w-0 max-w-full items-center", truncate && "overflow-hidden", styles.gap, className)}>
      {!suggested && <TagDot color={color} />}
      <span
        className={cn(styles.text, truncate && "min-w-0 flex-1 truncate")}
      >
        {name}
      </span>
    </span>
  );
}
